import { getMachinesWithSkillsUseCase } from "./get-machines-with-skills-use-case";
import store from "@src/reducers/store";

let cachedNamespace: string | undefined;
let machineIdsByDataSourcePromise: Promise<Record<
  string,
  string
> | null> | null = null;

export const getMachineIdForDataSourceUseCase = async (
  dataSourceId: string,
): Promise<string | undefined> => {
  const namespace = store.getState().yourSlice.authContext.customerNamespace;
  if (!namespace || !dataSourceId) return undefined;

  if (namespace !== cachedNamespace) {
    cachedNamespace = namespace;
    machineIdsByDataSourcePromise = null;
  }

  if (!machineIdsByDataSourcePromise) {
    const request = getMachinesWithSkillsUseCase().then((result) => {
      if (!result.success || !result.data) return null;

      return result.data.reduce<Record<string, string>>(
        (machineIds, machine) => {
          machine.skills?.forEach((skill) => {
            if (skill.type === "OPCUA" && skill.data_source_id) {
              machineIds[skill.data_source_id] = machine.id;
            }
          });
          return machineIds;
        },
        {},
      );
    });

    machineIdsByDataSourcePromise = request;
    void request.then((result) => {
      if (result === null && machineIdsByDataSourcePromise === request) {
        machineIdsByDataSourcePromise = null;
      }
    });
  }

  const machineIds = await machineIdsByDataSourcePromise;
  return machineIds?.[dataSourceId];
};
